<template>
  <div>
    <div
      class="container">
      <grid-row
        column-align="center">
        <grid-col
          col-size="4">
          <div
            class="logo-wrapper">
            <login-logo-mobile class="logo"/>
          </div>
          <div
            class="title-wrapper">
            <h1
              class="header margin-top-xl">
              {{ $t('emailVerification.title') }}
            </h1>
          </div>
        </grid-col>
      </grid-row>
      <grid-row
        v-if="showError"
        column-align="center">
        <grid-row
          col-size="4">
          <h2>{{ $t('emailVerification.error') }}</h2>
        </grid-row>
      </grid-row>
      <grid-row
        v-if="showSuccess"
        column-align="center">
        <grid-row
          col-size="4">
          <h2>{{ $t('emailVerification.success') }}</h2>
        </grid-row>
      </grid-row>
    </div>
  </div>
</template>

<script>
import LoginLogoMobile from '@/components/shared/logos/LoginLogoMobile';
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import LabelInput from '@/components/shared/forms/LabelInput';
import BtnPill from '@/components/shared/buttons/BtnPill';
import {mapActions} from 'vuex';

export default {
  components: {
    MainLayout,
    LoginLogoMobile,
    GridRow,
    GridCol,
    LabelInput,
    BtnPill
  },
  created () {

  },
  data () {
    return {
      uuid: this.$route.query.uuid,
      emailError: false,
      showError: false,
      showSuccess: false
    };
  },
  mounted () {
    this.emailVerification({context: this, verificationToken: this.uuid}).then(body => {
      this.handlerSuccess(body);
    }, error => {
      this.handlerError(error);
    });
  },
  computed: {
    displayNameErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.nameErrorUnique) {
        errorMessage = this.$t('user.userAlreadyExists');
      }
      return errorMessage;
    },
    displayPasswordErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.passwordError) {
        errorMessage = this.$t('user.passwordFormatMessage');
      }
      return errorMessage;
    },
    getUUID () {
      return this.uuid;
    }

  },
  methods: {
    ...mapActions([
      'emailVerification'
    ]),
    handlerSuccess (body) {
      this.showSuccess = true;
      if (body) {
        this.showSuccess = true;
      } else {
        this.showSuccess = false;
        this.showError = false;
      }
    },
    handlerError (error) {
      switch (error.status) {
        case 400:
          this.showSuccess = false;
          this.showError = true;
          break;

        default:
          this.showSuccess = false;
          this.showError = true;
          break;
      }
    }
  }
};

</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.logo-wrapper {
  margin-top: $sp-margin;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logo {
  width: 6rem;
  height: auto;
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

div.license-agreement {
  width: 100%;
  height: 200px;
  overflow: scroll;
  padding: $sp-margin-small;
  margin-bottom: $sp-margin-small;
  border: 1px solid $black-trans6;
  border-radius: $radius;
  overflow-x: hidden
}

.advice {
  font-size: $fs-xs;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/layouts/EmailVerification.vue